import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { GroupActionService } from "../../shared/group-action.service";
import { GroupActionNewReminderRequest } from "../../shared/group-action-new-reminder-request";
import * as moment from "moment";

@Component({
	selector: "app-sgadd-reminder",
	templateUrl: "./sgadd-reminder.component.html",
	styleUrls: ["./sgadd-reminder.component.css"],
})
export class SGAddReminderComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private dataService: GroupActionService
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedGroup = this.dialogConfig.data.SelectedGroup;

		this.GroupName = this.SelectedGroup.GroupName;

		this.loadScanStationReminder();
		this.loadSound();
	}

	//////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////

	ModeOption: string = "New";

	user: any;
	SchoolID: any;
	SelectedGroup: any;
	GroupName: string = "";

	errorMessage: string = "";

	//
	// Existing
	//
	SelectedStationReminderAlert: any;
	lstStationReminderAlert: any = [];
	StationReminderAlertLoading: boolean = true;

	//
	// New
	//
	Message: string = "";
	Messagecolor: string = "#000000";
	SelectedSound: any;
	lstSoundItems: any = [];
	SoundLoading: boolean = true;
	SelectedAlertTypeID: number = 1;
	lstAlertType: any = [
		{
			ID: 1,
			Desc: "Play Once",
		},
		{
			ID: 2,
			Desc: "Play Until Removed",
		},
		{
			ID: 3,
			Desc: "Play in Date Range",
		},
	];
	StartDate: Date = new Date();
	EndDate: Date = new Date();
	Priority: number = 2;
	lstPriority: any = [
		{
			ID: 1,
			Desc: "High",
		},
		{
			ID: 2,
			Desc: "Medium",
		},
		{
			ID: 3,
			Desc: "Low",
		},
	];
	EntryMode: boolean = true;
	ExitMode: boolean = true;
	MealMode: boolean = true;
	AccessMode: boolean = true;
	TimeStampMode: boolean = true;
	EventEntryMode: boolean = true;
	EventExitMode: boolean = true;
	ParentPortalSendNotification: boolean = false;
	StudentPortalSendNotification: boolean = false;
	StaffPortalSendNotification: boolean = false;
	audio: any = new Audio();

	AddAutomatically: boolean = false;

	Processing: boolean = false;

	//////////////////////////////////////////////////////

	//////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////

	loadScanStationReminder() {
		this.StationReminderAlertLoading = true;

		var result = this.dataService.GroupActionExistingReminderSelectList(this.SchoolID, this.SelectedGroup.GroupID);
		result.subscribe(
			(response) => {
				this.lstStationReminderAlert = response;

				this.SelectedStationReminderAlert = this.lstStationReminderAlert[0];

				this.StationReminderAlertLoading = false;
			},
			(error) => {
				this.StationReminderAlertLoading = false;
			}
		);
	}

	loadSound() {
		this.SoundLoading = true;

		//
		// Load school sounds or district-only sounds?
		// School-Only sounds might break for district-level alert
		//
		var result = this.dataService.LoadSoundPopupList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstSoundItems = response;

				this.lstSoundItems.unshift({
					SoundLibraryID: -1,
					SoundFile: "None",
					SoundData: null,
				});

				this.SelectedSound = this.lstSoundItems[0];

				this.SoundLoading = false;
			},
			(error) => {
				this.SoundLoading = false;
			}
		);
	}

	//////////////////////////////////////////////////////

	//////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		if (this.ModeOption == "Existing") {
			if (this.SelectedStationReminderAlert == undefined || this.SelectedStationReminderAlert.StationReminderAlert == -1) {
				this.errorMessage = "Select a reminder to add to the group, or create a new one";
				return;
			}

			this.onAddExisting();
		} else if (this.ModeOption == "New") {
			if (this.Message == undefined || String(this.Message).trim() == "") {
				this.errorMessage = "Enter a reminder message";
				return;
			}

			var fsDate = "";
			var feDate = "";

			if (this.SelectedAlertTypeID == 3) {
				fsDate = moment(this.StartDate).format("MM/DD/YYYY");
				feDate = moment(this.EndDate).format("MM/DD/YYYY");

				if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
					this.errorMessage = "Invalid Start Date";
					return;
				}
				if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
					this.errorMessage = "Invalid End Date";
					return;
				}
			}

			this.onAddNew(fsDate, feDate);
		}
	}

	onAddExisting() {
		this.Processing = true;

		var result = this.dataService.GroupActionExistingReminderInsert(
			this.SelectedGroup.GroupID,
			this.SelectedStationReminderAlert.StationReminderAlertID,
			this.AddAutomatically == true ? 0 : 1
		);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.ref.close(1);
				} else {
					this.errorMessage = response.ErrorMessage;
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onAddNew(fsDate: string, feDate: string) {
		this.Processing = true;

		var parms: GroupActionNewReminderRequest = {
			GroupID: this.SelectedGroup.GroupID,
			AddStudentPrompt: this.AddAutomatically == true ? 0 : 1,
			SchoolID: this.SchoolID,
			Message: this.Message,
			MessageFontColor: this.Messagecolor,
			SoundLibraryID: this.SelectedSound.SoundLibraryID,
			AlertType: this.SelectedAlertTypeID,
			StartDate: this.SelectedAlertTypeID != 3 ? "" : fsDate,
			EndDate: this.SelectedAlertTypeID != 3 ? "" : feDate,
			Priority: this.Priority,
			EntryMode: this.EntryMode == true ? 1 : 0,
			ExitMode: this.ExitMode == true ? 1 : 0,
			MealMode: this.MealMode == true ? 1 : 0,
			AccessMode: this.AccessMode == true ? 1 : 0,
			TimeStampMode: this.TimeStampMode == true ? 1 : 0,
			EventEntryMode: this.EventEntryMode == true ? 1 : 0,
			EventExitMode: this.EventExitMode == true ? 1 : 0,
			ParentPortalSendNotification: this.ParentPortalSendNotification == true ? 1 : 0,
			StudentPortalSendNotification: this.StudentPortalSendNotification == true ? 1 : 0,
			StaffPortalSendNotification: this.StaffPortalSendNotification == true ? 1 : 0,
		};

		var result = this.dataService.GroupActionNewReminderInsert(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.ref.close(1);
				} else {
					this.errorMessage = response.ErrorMessage;
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.onStop();
		this.ref.close(0);
	}

	onPlay() {
		this.errorMessage = "";

		if (this.SelectedSound == null || this.SelectedSound.SoundData == null) {
			this.errorMessage = "Select a sound to play";
			return;
		}

		this.audio.src = this.SelectedSound.SoundData;
		this.audio.load();
		this.audio.play();
	}

	onStop() {
		this.errorMessage = "";

		if (this.audio.src != null && this.audio.currentTime > 0) {
			this.audio.pause();
			this.audio.currentTime = 0;
		}
	}

	//////////////////////////////////////////////////////

	//////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////
	onSoundChange(val) {
		this.SelectedSound = val;

		this.onStop();
	}
	//////////////////////////////////////////////////////

	//////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////

	IsLoading() {
		return this.StationReminderAlertLoading == true || this.SoundLoading == true || this.Processing == true;
	}

	//////////////////////////////////////////////////////
}
